<topo-modal
  id="new-notification-modal"
  [isActive]="isActive"
  [backgroundCanClose]="false"
  [width]="924"
  rawHeight="90%"
  [isCard]="true"
  (close)="close()"
  [showLoadingOverlay]="isTakingScreenshot"
  [loadingMessage]="'COMMUNICATIONS.GENERATING-MAP-SCREENSHOT' | translate">
  <div class="modal-header">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      @if (notification) {
        <h5 class="mx-4 my-4">
          {{ (notification?.uId === GUID_EMPTY ? 'COMMUNICATIONS.NEW-NOTIFICATION' : 'COMMUNICATIONS.MODIFY-NOTIFICATION') | translate }}
        </h5>
      }
      <div
        class="dialog-close"
        (click)="close()">
        <i class="icon icon-close-X"></i>
      </div>
    </div>

    @if (!!selectedTemplate) {
      <topo-tabs
        style="position: relative; top: 1px"
        [selectedTabIndex]="selectedTabIndex"
        [tabs]="tabs"
        [iscautionicons]="selectedTabIndex == 1 ? false : (isDesignerSmsOverLimitReached$ | async)"
        [tabBadgeMap]="{ '2': { value: totalRecipients } }"
        [disabledTabs]="disabledTabs"
        (selectedTabIndexChanged)="tabChanged($event)"></topo-tabs>
    }
  </div>

  <div class="modal-body">
    <!-- Template List -->
    @if (!selectedTemplate && canSelectTemplate) {
      <div class="template-selector">
        <div
          class="template-filter"
          [class.float]="!selectedTemplate">
          <div class="title">{{ 'COMMUNICATIONS.TEMPLATE' | translate }}</div>
          <input
            class="input is-medium"
            style="height: 48px !important"
            type="text"
            placeholder="{{ 'COMMUNICATIONS.FILTER-TEMPLATES' | translate }}"
            (ngModelChange)="templateFilter.set($event)"
            [ngModel]="templateFilter()" />
        </div>
        <div class="templates-container">
          @let hasTemplateGroups = templateGroups()?.length;
          @if (hasTemplateGroups) {
            @let typesTab = 'COMMUNICATIONS.TAB-TEMPLATE-TYPES' | translate | uppercase;
            @let groupsTab = 'COMMUNICATIONS.TAB-TEMPLATE-GROUPS' | translate | uppercase;
            <topo-tabs
              [selectedTabIndex]="templateSelectDisplayType()"
              [tabs]="[typesTab, groupsTab]"
              (selectedTabIndexChanged)="templateSelectDisplayType.set($event)" />
          }
          @for (group of groupedTemplatesForSelect(); track group.id) {
            <topo-template-select-expansion-panel
              [label]="group.label"
              [templates]="group.templates"
              (onTemplateSelected)="selectTemplate($event)"
              [forceExpand]="!!templateFilter()" />
          }
        </div>
      </div>
    }

    @if (!!selectedTemplate) {
      <!-- Summary -->
      @if (selectedTabIndex === 0) {
        <section class="summary-section">
          <!-- Selected Template -->
          <div class="selected-template-container">
            <div class="title">{{ 'COMMUNICATIONS.TEMPLATE' | translate }}</div>
            <div class="selected-template">
              <i
                class="template-type-icon"
                [ngClass]="getIconClass(selectedTemplate.type)"></i>
              <span>{{ selectedTemplate.name }}</span>
              <i
                class="deselect-template icon icon-small_close-X"
                (click)="selectedTemplate = null; selectedTemplateUId = null"></i>
            </div>
            <div class="title mt-2">
              {{ 'COMMUNICATIONS.NAME' | translate }}
              <input
                class="input is-medium mt-1"
                type="text"
                placeholder="{{ 'COMMUNICATIONS.NAME' | translate }}"
                [(ngModel)]="notificationName" />
            </div>
          </div>
          @if (hasTranslations) {
            <div
              class="field"
              fxLayout="row"
              fxLayoutGap="12px"
              fxLayoutAlign="space-between center">
              <label>{{ 'COMMUNICATIONS.ENFORCE-DOC-LANGUAGE' | translate }}</label>
              <div>
                <topo-switch
                  [checked]="limitByLanguage"
                  (checkChanged)="setLimitByLanguage($event)"></topo-switch>
              </div>
            </div>
          }
          <!-- Message Language -->
          @if (languages?.length > 0) {
            <ng-container *ngTemplateOutlet="languageSelector" />
          }
          <!-- Message -->
          @if (hasHTMLMessage) {
            <div class="notification-message-container">
              <div
                fxLayout="row"
                fxLayoutAlign="space-between center">
                <div class="title">{{ 'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate }}</div>
                @if (hasSMSMessage) {
                  <div
                    fxLayout="row"
                    fxLayoutGap="8px"
                    fxLayoutAlign="start center"
                    class="mb-1">
                    <div class="separate-sms-check">{{ 'COMMUNICATIONS.USE-SEPARATE-SMS-MESSAGE' | translate }}</div>
                    <topo-switch
                      [checked]="!singleMessageMode"
                      (checkChanged)="setSingleMessageMode($event)"></topo-switch>
                  </div>
                }
              </div>
              <div class="edit-message-container">
                <quill-editor
                  [styles]="{ height: '122px' }"
                  placeholder="{{ 'COMMUNICATIONS.NOTIFICATION-MESSAGE' | translate }}"
                  [modules]="editorModules"
                  [(ngModel)]="selectedMessage"
                  (onContentChanged)="onEditorContentChanged($event)"
                  (onEditorCreated)="editorCreated($event)"></quill-editor>
                @if (singleMessageMode) {
                  <div
                    class="sms-counter"
                    fxLayout="row"
                    fxLayoutAlign="end center">
                    {{ messageCharCount }}
                  </div>
                }
              </div>
            </div>
          }
          <!-- SMS Message -->
          @if (hasSMSMessage && (!singleMessageMode || !hasHTMLMessage)) {
            <div class="sms-notification-message-container">
              <div class="field flex-label">
                <div class="title mb-0">{{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}</div>
                <i
                  [matTooltip]="'COMMUNICATIONS.SMS-TOOLTIP-MESSAGE' | translate"
                  class="tooltip-icon-info icon icon-help"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="500"
                  [matTooltipHideDelay]="500000"></i>
              </div>
              @if (designExpanded && canEditMessage) {
                <div>
                  <mat-form-field
                    appearance="outline"
                    class="full-width">
                    <textarea
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="8"
                      cdkAutosizeMaxRows="8"
                      placeholder="{{ 'COMMUNICATIONS.SMS-NOTIFICATION-MESSAGE' | translate }}"
                      [(ngModel)]="selectedSMSMessage"
                      (ngModelChange)="smsNotificationMessageChanged($event)"
                      (keyup)="smsNotificationMessageUpdated($event)"
                      (keydown)="preventInputWhenLimitReached($event)"
                      [maxlength]="absoluteMaxLimit"></textarea>
                    <div class="character-count-container">
                      <div class="flex-between">
                        <!-- Character counter that changes color based on limit status -->
                        <span
                          class="character-count"
                          [ngClass]="{ 'warning': isApproachingLimit(), 'error': isOverLimit() }">
                          {{
                            (isOverLimit() === true ? 'COMMUNICATIONS.SMS-VALIDATION-OVER' : 'COMMUNICATIONS.SMS-VALIDATION-REMAIN')
                              | translate: { value: getRemainingCharacters() }
                          }}
                        </span>
                      </div>
                      <!-- Progress bar that visualizes character usage -->
                      <mat-progress-bar
                        [ngClass]="getProgressBarColor()"
                        [value]="getProgressValue()"></mat-progress-bar>
                    </div>
                  </mat-form-field>
                  <!-- Validation messages section -->
                  <div class="validation-messages">
                    <!-- Error message when over the limit -->
                    @if (isOverLimit()) {
                      <div class="error-message">SMS must be fewer than {{ singleSmsLimit + 1 }} characters</div>
                    }
                    <!-- Warning about multi-part SMS -->
                    @if (isApproachingLimit()) {
                      <div class="warning-message">
                        {{ 'COMMUNICATIONS.SMS-WARNING-MESSAGE' | translate }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <!-- Confirmation -->
          @if (isSafetyCheckType() && hasConfirmation) {
            <ng-container *ngTemplateOutlet="confirmationTemplate"></ng-container>
          }
          <!-- Recipients -->
          <div class="recipients-container">
            <div
              fxLayout="row"
              fxLayoutAlign="space-between center">
              <div class="title">{{ 'COMMUNICATIONS.RECIPIENTS' | translate }}</div>
              <div class="manage-recipients">
                <a (click)="manageRecipients()">{{ 'COMMUNICATIONS.MANAGE-RECIPIENTS' | translate }}</a>
              </div>
            </div>
            <div class="recipients-summary">
              <span class="total-recipients">
                {{ 'COMMUNICATIONS.RECIPIENTS-STATS' | translate: { number: totalRecipients } }}
              </span>
              :
              <span class="added-recipients">
                {{ 'COMMUNICATIONS.ADDED-RECIPIENTS-STATS' | translate: { number: totalAddedRecipients } }}
              </span>
              @if (totalAssetRecipients) {
                <span class="added-recipients">
                  , {{ 'COMMUNICATIONS.ASSETS-RECIPIENTS-STATS' | translate: { number: totalAssetRecipients } }}
                </span>
              }
            </div>
          </div>
          <!-- Severity -->
          @if (!!selectedTemplate) {
            <div class="severity-container">
              <div class="title">{{ 'COMMUNICATIONS.NOTIFICATION-SEVERITY' | translate }}</div>
              <div
                fxLayout="row"
                fxLayoutAlign="stretch center"
                fxLayoutGap="8px">
                @for (severityItem of ratingScaleLevels; track severityItem.uId) {
                  <div
                    class="severity-box"
                    (click)="selectSeverity(severityItem.level)"
                    [ngStyle]="{
                      'background-color': severityItem.level === selectedSeverity ? severityItem.htmlColorCode : null,
                      'color': severityItem.level === selectedSeverity ? severityItem.textColor : null,
                      'border-color': severityItem.level === selectedSeverity ? severityItem.htmlColorCode : null
                    }">
                    {{ severityItem.label }}
                  </div>
                }
              </div>
            </div>
          }
          <!-- Channels -->
          @if (hasChannels) {
            <div class="channels-container">
              <topo-template-channels-selection
                [readonlyMode]="false"
                [skippedChannels]="skippedChannels"
                [viewOnly]="true"
                (skippedChanged)="skippedChanged($event)"
                (showAdvacedSchedules)="showAdvacedSchedules()"
                [channelsCascadeSettings]="notification?.channelsCascadeSettings"></topo-template-channels-selection>
            </div>
          }
        </section>
      }
      <!-- Channels -->
      @if (selectedTabIndex === 3) {
        <section class="channels-section">
          @if (hasChannels) {
            <topo-template-channels-selection
              [readonlyMode]="true"
              [canSkip]="true"
              [channelsCascadeSettings]="notification?.channelsCascadeSettings"
              [allowedChanges]="allAllowedChangesForChannels"
              [skippedChannels]="skippedChannels"
              (skippedChanged)="skippedChanged($event)"
              [responseRequired]="isSafetyCheckType()"></topo-template-channels-selection>
          }
          @if (!hasChannels) {
            <div class="no-channels">
              {{ 'COMMUNICATIONS.NO-SELECTED-CHANNELS' | translate }}
            </div>
          }
        </section>
        @if (notification?.channelsCascadeSettings?.advancedMode === true) {
          <div>
            <div class="section-title">{{ 'COMMUNICATIONS.NOTIFICATION-TIMELINE' | translate }}</div>
            <topo-comms-notification-timeline-chart-widget
              [notification]="notificationForTimeline"></topo-comms-notification-timeline-chart-widget>
          </div>
        }
      }
      <!-- Message Templates -->
      <section
        class="message-templates-section"
        [class.hidden]="selectedTabIndex !== 1">
        @if (designExpanded && languages?.length > 0) {
          <ng-container *ngTemplateOutlet="languageSelector" />
        }
        <topo-tabs
          [selectedTabIndex]="selectedContentTabIndex"
          [tabs]="contentTabs"
          [icons]="contentTabIcons"
          [iscautionicons]="isDesignerSmsOverLimitReached$ | async"
          (selectedTabIndexChanged)="contentTabChanged($event)"></topo-tabs>
        @if (contentTemplate?.channelUId) {
          <div class="designer-body">
            @if (isEmailTemplate(contentTemplate)) {
              <div class="mb-5">
                <input
                  class="input is-medium"
                  type="text"
                  placeholder="{{ 'COMMUNICATIONS.EMAIL-SUBJECT' | translate }}"
                  [ngModel]="templateSubjects[contentTemplate.uId]"
                  (ngModelChange)="emailSubjectChanged(contentTemplate, $event)" />
              </div>
            }
            @if (hasTemplateTitle(contentTemplate)) {
              <div class="mb-5">
                <input
                  class="input is-medium"
                  type="text"
                  maxlength="90"
                  placeholder="{{ 'COMMUNICATIONS.TITLE' | translate }}"
                  [ngModel]="templateSubjects[contentTemplate.uId]"
                  (ngModelChange)="emailSubjectChanged(contentTemplate, $event)" />
              </div>
            }
            @if (hasTemplateSummary(contentTemplate)) {
              <div class="mb-5">
                <textarea
                  maxlength="270"
                  class="input is-small is-fullwidth summary"
                  placeholder="{{ 'COMMUNICATIONS.SUMMARY' | translate }}"
                  cols="6"
                  [ngModel]="templateSummary[contentTemplate.uId]"
                  (ngModelChange)="templateSummaryChanged(contentTemplate, $event)"></textarea>
              </div>
            }
            <topo-comms-template-designer
              width="100%"
              slackMessageWidth="100%"
              [culture]="selectedCulture"
              [editable]="false"
              [editableControlTypes]="editableControlTypes"
              [deletableControlTypes]="deletableControlTypes"
              [messageSettings]="notification?.messageSettings"
              [template]="contentTemplate"
              [overrides]="notification?.viewControlOverrides"
              [documentContext]="documentContext"
              (changed)="templateDesignChanged($event)"
              (controlEdited)="templateDesignControlEdited($event)"
              (controlDeleted)="templateDesignControlDeleted($event)"
              (controlChanged)="templateDesignControlChanged($event)"></topo-comms-template-designer>
          </div>
        }
        @if (hasSMSMessage && isSmsTab) {
          <div class="progress-designer">
            <div class="progress-container">
              <div class="character-count-container">
                <div class="flex-between">
                  <span
                    class="character-count"
                    [ngClass]="{ 'warning': isDesignerApproachingLimit(), 'error': isDesignerSmsOverLimitReached$ | async }">
                    {{
                      ((isDesignerSmsOverLimitReached$ | async) === true
                        ? 'COMMUNICATIONS.SMS-VALIDATION-OVER'
                        : 'COMMUNICATIONS.SMS-VALIDATION-REMAIN'
                      ) | translate: { value: getDesignerRemainingCharacters() }
                    }}
                  </span>
                </div>
                <mat-progress-bar
                  [value]="getDesignerProgressValue()"
                  [ngClass]="getDesignerProgressColor()"></mat-progress-bar>
              </div>
              <div class="validation-messages">
                <!-- Error message when over the limit -->
                @if (isDesignerSmsOverLimitReached$ | async) {
                  <div class="error-message">
                    {{ 'COMMUNICATIONS.SMS-VALIDATION-LIMIT-MESSAGE' | translate: { value: singleSmsLimit + 1 } }}
                  </div>
                }
                <!-- Warning about multi-part SMS -->
                @if (isDesignerApproachingLimit()) {
                  <div class="warning-message">
                    {{ 'COMMUNICATIONS.SMS-WARNING-MESSAGE' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </section>
      <!-- Recipients -->
      <section
        class="recipients-section"
        [class.hidden]="selectedTabIndex !== 2">
        <ng-container>
          <div>
            <div class="recipients">
              @if (selectedTemplate) {
                <topo-comms-recipients-selection
                  [includeUsers]="true"
                  [includeGroups]="false"
                  [includeDistro]="true"
                  [includeDatasets]="true"
                  [showAddedRecipients]="true"
                  [addToTotalRecipients]="includeAssetsRecipients ? totalAssetRecipients : 0"
                  (selectedRecipientsChanged)="selectedRecipientsChanged($event)"
                  [toRecipientSettings]="notification?.recipientSettings"></topo-comms-recipients-selection>
              }
            </div>
            <topo-comms-notification-document-selection
              [notification]="notification"
              [dataset]="_dataset"
              [document]="_document"
              (selectedRecipientsChanged)="notificationDocumentRecipientsChanged($event)"
              (recipientCountChanged)="notificationDocumentRecipientCountChanged($event)"></topo-comms-notification-document-selection>
            <topo-comms-related-assets-recipients-selection
              [notification]="notification"
              [dataset]="_dataset"
              [document]="_document"
              (selectedRecipientsChanged)="selectedRelatedAssetRecipientsChanged($event)"
              (recipientCountChanged)="relatedAssetRecipientCountChanged($event)"></topo-comms-related-assets-recipients-selection>
            <topo-comms-recipient-assets-selection
              #assetsSelection
              [notification]="notification"
              [document]="_document"
              [closestAssetRequest]="closestAssetRequest"
              (selectedRecipientsChanged)="selectedAssetRecipientsChanged($event)"
              (assetsElementSettingsChanged)="assetsElementSettingsChanged($event)"
              (totalAssetsCountChanged)="totalAssetsCountChanged($event)"></topo-comms-recipient-assets-selection>
          </div>
        </ng-container>
      </section>
    }
  </div>

  <div class="modal-footer">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="ml-5 mb-4">
      <div fxLayoutAlign="start">
        <div class="mr-4">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'COMMUNICATIONS.BUTTONS.CANCEL' | translate }}
          </button>
        </div>
        @if (selectedTemplate && !inMapContext) {
          <div>
            <button
              class="button is-secondary"
              [disabled]="isDesignerSmsOverLimitReached$ | async"
              (click)="saveClick()">
              {{ 'COMMUNICATIONS.BUTTONS.SAVE' | translate }}
            </button>
          </div>
        }
      </div>
      @if (selectedTemplate) {
        <div fxLayoutAlign="end">
          @for (action of buttonWorkflowActions; track action.uId; let i = $index) {
            <div>
              <button
                class="button mr-4"
                [ngClass]="{ 'is-primary': i === buttonWorkflowActions?.length - 1 }"
                [disabled]="isDesignerSmsOverLimitReached$ | async"
                (click)="saveClick(action?.destinationStepUId)">
                {{ action.name }}
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div style="position: relative !important; top: 200px">
    <ngx-spinner
      bdColor="rgba(0,0,0,.1)"
      size="medium"
      color="#4D33CC"
      type="ball-clip-rotate"
      [fullScreen]="false"
      [zIndex]="998">
      <h5
        style="position: absolute !important; top: 36px; right: -184px; width: 300px"
        class="mx-4 my-4">
        {{ 'MAP.GATHERING-CONTACTS' | translate }}
      </h5>
    </ngx-spinner>
  </div>
</topo-modal>

<topo-confirm
  [isActive]="showConfirmValidation"
  (respond)="onConfirmValidation($event)"
  title="{{ 'COMMUNICATIONS.CONFIRM-VALIDATION' | translate }}"
  [listItems]="validationList"
  [hideNo]="!isConfirmWarning"
  message="{{ (isConfirmWarning ? 'COMMUNICATIONS.VALIDATION-WARNING-MESSAGE' : 'COMMUNICATIONS.VALIDATION-ERROR-MESSAGE') | translate }}"
  yesText="{{ (isConfirmWarning ? 'COMMUNICATIONS.CONFIRM-YES' : 'COMMUNICATIONS.CONFIRM-OK') | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
  icon="icon-close-X"></topo-confirm>

<topo-confirm
  [isActive]="showChangeTemplateConfirmation"
  (respond)="onConfirmTemplateChange($event)"
  title="{{ 'COMMUNICATIONS.CONFIRM-CANCEL' | translate }}"
  message="{{ 'COMMUNICATIONS.CONFIRM-CHANGE-TEMPLATE-MESSAGE' | translate }}"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
  icon="icon-close-X"></topo-confirm>

<topo-confirm
  [isActive]="showSendConfirmation"
  (respond)="onConfirmSend($event)"
  [title]="sendConfirmationTitle"
  [htmlMessage]="sendConfirmationMessage"
  [listItems]="channelMessageList"
  yesText="{{ 'COMMUNICATIONS.CONFIRM-YES' | translate }}"
  noText="{{ 'COMMUNICATIONS.CONFIRM-NO' | translate }}"
  icon="icon-alert_solid"></topo-confirm>

<ng-template #languageSelector>
  <div class="field language-selection">
    <div class="title">{{ 'COMMUNICATIONS.LANGUAGE' | translate }}</div>
    <div class="select is-primary is-fullwidth is-medium">
      <select
        style="height: 48px"
        [(ngModel)]="selectedCulture"
        (change)="cultureChanged()">
        @for (lang of languages; track lang) {
          <option [ngValue]="lang">
            {{ getLanguageDisplay(lang) }}
          </option>
        }
      </select>
    </div>
  </div>
</ng-template>

<ng-template #confirmationTemplate>
  <div class="confirmation-container">
    <div
      fxLayout="row"
      fxLayoutGap="24px">
      <div fxFlex>
        <div class="title">{{ 'COMMUNICATIONS.CONFIRMATION-QUESTION' | translate }}</div>
        <div class="question">
          {{ getConfirmationText() }}
        </div>
      </div>
      <div
        fxFlex
        fxLayout="column"
        fxLayoutGap="8px">
        <div class="title">{{ 'COMMUNICATIONS.CONFIRMATION-ANSWERS' | translate }}</div>
        @for (
          confirmationButton of selectedTemplate?.defaultMessageSettings?.confirmationButtons;
          track confirmationButton.uId;
          let i = $index
        ) {
          <div
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="8px">
            <div class="answer-marker">{{ i + 1 }}</div>
            <span>{{ getConfirmationButtonText(confirmationButton) }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
